import { itx } from "../../../src/translationItx/itx";
import React from "react";
import { C1_EloItem_PlugType } from "../types/C1_EloTypes";
import { C1_TagFunction } from "./C1_TagFunction";

/** Identifies special outlets while leaving ordinary sockets without a symbol. */
export function C1_PlugTagFunction({ x, y, plugType, color }: {
  x: number;
  y: number;
  plugType: C1_EloItem_PlugType | undefined;
  color: string;
}) {
  let label: string | undefined;
  switch (plugType) {
    case C1_EloItem_PlugType.USB: label = "USB"; break;
    case C1_EloItem_PlugType.LAN: label = "LAN"; break;
    case C1_EloItem_PlugType.LAN2: label = "2x LAN"; break;
    case C1_EloItem_PlugType.TV: label = itx("c1.ui.TV", "TV"); break;
    default:
      if (!plugType?.startsWith(C1_EloItem_PlugType.V230Switch)) return null;
  }
  return <C1_TagFunction x={x} y={y} label={label} color={color} />;
}
